import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LabHome from '../../components/Laboratory/LabHome';
import ResultImages from '../../components/Laboratory/LabImages/ResultImages';
import LabDetailForm from '../../components/Laboratory/LabDetailForm';
import * as LaboratoryAction from '../../redux/Laboratory/LaboratoryAction';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useCheckAccess from '../../hooks/useCheckAccess';

const useStyle = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        // overflow: "hidden",
        // minHeight: 'calc(100vh - 100px)',
        background: '#fff',
        borderRadius: '8px',
        position: 'relative',
        [theme.breakpoints.down(1025)]: {
            borderRadius: '8px'
        }
    },
    loadingContainer: ({ initialized }) => ({
        position: 'absolute',
        top: initialized ? undefined : 0,
        right: initialized ? undefined : 0,
        bottom: initialized ? 10 : 0,
        left: initialized ? 10 : 0,
        background: initialized ? undefined : 'white',
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        height: '100%',
        width: '100%'
    })
}));
function Laboratory({ match: { params }, location }) {
    const dispatch = useDispatch();
    const { notEditClinical } = useCheckAccess();
    const { loading, initialized } = useSelector((store) => store.laboratory);
    const classes = useStyle({ initialized });
    const { path } = useRouteMatch();
    const labHome = `/${params?.clinicId}/patient/${params.id}/laboratory`;
    let background = location.state && location.state.background;
    useEffect(() => {
        dispatch(LaboratoryAction.getLaboratoryFactors({ offset: 0 }));
        dispatch(LaboratoryAction.getLaboratoryTests(params.id));
    }, [dispatch, params.id]);

    return (
        <div className={classes.container} dir="ltr">
            {!loading && (
                <Switch location={background || location}>
                    <Route exact path={path} component={LabHome} />
                    {!notEditClinical && (
                        <>
                            <Route
                                path={`${path}/images_result/:image_result_id`}
                                component={ResultImages}
                            />
                            <Route
                                path={`${path}/result/form/:group_id/:result_id?`}
                                component={LabDetailForm}
                            />
                        </>
                    )}
                </Switch>
            )}

            {loading && labHome === location.pathname && (
                <div className="loadingContainer">
                    <CircularProgress size={initialized ? 30 : undefined} />
                </div>
            )}
        </div>
    );
}
Laboratory.propTypes = {
    match: PropTypes.any,
    location: PropTypes.any
};

export default Laboratory;
